import React from 'react';
import { Beschreibung } from '../types/process';
import './ProcessDescription.css';

interface ProcessDescriptionProps {
  beschreibung: Beschreibung;
  hinweise: string[];
}

const ProcessDescription: React.FC<ProcessDescriptionProps> = ({
  beschreibung,
  hinweise
}) => {
  return (
    <div className="process-description">
      <section className="description-section">
        <h3>Problem</h3>
        <p>{beschreibung.problem}</p>
      </section>

      <section className="description-section">
        <h3>Scope</h3>
        <p>{beschreibung.scope}</p>
      </section>

      <section className="description-section">
        <h3>Rollen & Verantwortlichkeiten</h3>
        <div className="roles-table">
          <table>
            <thead>
              <tr>
                <th>Rolle</th>
                <th>Verantwortung</th>
              </tr>
            </thead>
            <tbody>
              {beschreibung.rollen.map((rolle, index) => (
                <tr key={index}>
                  <td className="role-name">{rolle.name}</td>
                  <td>{rolle.verantwortung}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="description-section">
        <h3>Prozesse</h3>
        {beschreibung.prozesse.map((prozess, index) => (
          <div key={index} className="process-detail-card">
            <h4>{prozess.name}</h4>

            <div className="detail-row">
              <strong>Ziel:</strong>
              <p>{prozess.ziel}</p>
            </div>

            {prozess.eingaben.length > 0 && (
              <div className="detail-row">
                <strong>Eingaben:</strong>
                <ul>
                  {prozess.eingaben.map((eingabe, idx) => (
                    <li key={idx}>{eingabe}</li>
                  ))}
                </ul>
              </div>
            )}

            {prozess.ausgaben.length > 0 && (
              <div className="detail-row">
                <strong>Ausgaben:</strong>
                <ul>
                  {prozess.ausgaben.map((ausgabe, idx) => (
                    <li key={idx}>{ausgabe}</li>
                  ))}
                </ul>
              </div>
            )}

            {prozess.regeln.length > 0 && (
              <div className="detail-row">
                <strong>Regeln:</strong>
                <ul className="rules-list">
                  {prozess.regeln.map((regel, idx) => (
                    <li key={idx}>{regel}</li>
                  ))}
                </ul>
              </div>
            )}

            {prozess.risiken.length > 0 && (
              <div className="detail-row">
                <strong>Risiken:</strong>
                <ul className="risks-list">
                  {prozess.risiken.map((risiko, idx) => (
                    <li key={idx}>{risiko}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </section>

      <section className="description-section">
        <h3>Akzeptanzkriterien</h3>
        <ul className="acceptance-criteria">
          {beschreibung.akzeptanzkriterien.map((kriterium, index) => (
            <li key={index}>{kriterium}</li>
          ))}
        </ul>
      </section>

      {hinweise.length > 0 && (
        <section className="description-section hinweise-section">
          <h3>Offene Punkte & Hinweise</h3>
          <div className="hinweise-box">
            <ul>
              {hinweise.map((hinweis, index) => (
                <li key={index}>{hinweis}</li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </div>
  );
};

export default ProcessDescription;
